
import { Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";
export default class FieldLabel extends Vue {
  @Prop({ type: String, required: true }) title = "";
  @Prop({ type: Boolean }) required = false;
}
